<template>
  <div id="report-dialog">
    <el-dialog
      title=""
      :visible.sync="value"
      width="50%"
      :before-close="beforeClose"
      append-to-body="true"
      top="5vh"
    >
      <iframe
        allowfullscreen="true"
        class="scroll"
        :src="pdfUrl + '#toolbar=0'"
        frameborder="0"
        scrolling="yes"
        style="width: 100%;height: 650px;"
      ></iframe>
      <div slot="footer">
        <el-button @click="beforeClose">取 消</el-button>
        <el-button type="primary" @click="confirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props:{
    value: {
      type: Boolean,
      default: false
    },
    pdfUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {},
  methods: {
    beforeClose() {
      this.dialogVisible = false;
      this.$emit("input", false);
    },
    confirm() {
      this.dialogVisible = true;
    }
  },
};
</script>

<style lang="less">
#report-dialog {
  iframe {
    width: 100%;
  }
}
</style>
